import { clearCache } from './axiosWrapper';

export const globalTtl = { ttl: 60 * 1000 * 120 };

const cacheKeyConstructor = (url: string, method: string, headers: any) => {
  return {
    url: url,
    method: method,
    headers: headers,
    params: {},
  };
};

export const clearHealthCheckCache = async (
  url: string,
  method: string,
  entityType: string,
  accounts: Array<Api.IEssAccountData>
) => {
  interface IHealthRequest {
    entityType: string;
    accountReferences: Array<string>;
  }

  let headers: IHealthRequest = {
    entityType,
    accountReferences: accounts.map((account: Api.IEssAccountData) => {
      return account.essAccountID;
    }),
  };
  await clearCache(cacheKeyConstructor(url, method, headers));
};
